// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/loader.js';

import { paths } from '../generated/loader';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('loader', Original, paths);
